// Runtime config loaded from /config.json (written by deploy script)
let config = {
  apiEndpoint: '',
  userPoolId: '',
  userPoolClientId: '',
  identityPoolId: '',
  region: 'us-east-1',
};

export async function loadConfig() {
  try {
    const resp = await fetch('/config.json');
    if (resp.ok) {
      config = await resp.json();
    }
  } catch (e) {
    console.warn('Could not load config.json, using defaults');
  }
  return config;
}

export function getConfig() {
  return config;
}
